var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBackIos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "arrow_back_ios"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_824_9479",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_824_9479)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arrow_back_ios_2",
    d: "M16.6672 35.5126L1.1543 19.9997L16.6672 4.48682L18.4397 6.25932L4.6993 19.9997L18.4397 33.7402L16.6672 35.5126Z",
    fill: "#232323"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBackIos);
export default __webpack_public_path__ + "static/media/arrow_back_ios.3f5cd0bbfcd8da441318e4550762b598.svg";
export { ForwardRef as ReactComponent };